import component from './comparison.component'
import config from './comparison.config'

const module = angular.module('mpa.pages.comparison', [])

module.config(config).component('comparisonPageComponent', component)

export default module.name
